<div class="promoted-content-title" [class.promoted-content-title--loading]="loadingDetails">
	<div class="title-content">
		<div class="title-icon-placeholder" *ngIf="typeIconUrl">
			<img [src]="typeIconUrl" [alt]="typeLabel || 'Promoted content icon'" />
		</div>

		<div class="title-body" [ngSwitch]="layoutVariant">
			<ng-container *ngSwitchCase="'single'">
				<ng-container *ngTemplateOutlet="singleOfferTemplate"></ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="'gallery'">
				<ng-container *ngTemplateOutlet="galleryTemplate"></ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="'media'">
				<ng-container *ngTemplateOutlet="mediaTemplate"></ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="'html'">
				<ng-container *ngTemplateOutlet="htmlTemplate"></ng-container>
			</ng-container>
			<ng-container *ngSwitchDefault>
				<ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
			</ng-container>
		</div>
	</div>

	<div class="expand-indicator" *ngIf="expandable" [class.expand-indicator--expanded]="expanded">
		<i class="fal" [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
	</div>
</div>

<ng-template #titleBlock>
	<div class="title-text">
		<div class="title-main">{{ defaultTitle }}</div>
	</div>
</ng-template>

<ng-template #singleOfferTemplate>
	<ng-container *ngTemplateOutlet="titleBlock"></ng-container>
	<app-real-estate-listing-preview
		[imageUrl]="primaryImageUrl"
		[listing]="realEstateListing"
		[loadingDetails]="loadingDetails"
		[showImagePlaceholder]="true"
	></app-real-estate-listing-preview>
</ng-template>

<ng-template #galleryTemplate>
	<ng-container *ngTemplateOutlet="titleBlock"></ng-container>
	<ng-container *ngIf="context as current">
		<div class="title-gallery" *ngIf="galleryImages.length">
			<div class="gallery-collapsed" *ngIf="!galleryIsExpanded">
				<div class="image-wrapper" *ngFor="let img of galleryPreviewImages">
					<img [src]="img" alt="Content image" class="content-thumbnail" />
				</div>
				<button type="button" class="hidden-images-btn" *ngIf="galleryRemainderCount > 0">
					+{{ galleryRemainderCount }}
				</button>
			</div>
			<div class="gallery-expanded" *ngIf="galleryIsExpanded">
				<div class="images-grid">
					<div class="image-wrapper" *ngFor="let img of galleryImages">
						<img [src]="img" alt="Content image" class="content-thumbnail" />
					</div>
				</div>
				<button
					type="button"
					class="close-gallery-btn"
					(click)="toggleShowAllImages(current, $event)"
					aria-label="Close image gallery"
				>
					<i class="fal fa-times"></i>
				</button>
			</div>
		</div>
	</ng-container>
</ng-template>

<ng-template #mediaTemplate>
	<div class="text-decoration-none d-flex align-items-center h-100 w-100">
		<div class="row flex-nowrap g-2 align-items-center promoted-content-card m-0 w-100">
			<div class="col-auto img-container">
				<ng-container *ngIf="singleMediaImage; else mediaPlaceholder">
					<img [src]="singleMediaImage" class="image-square" alt="Content preview" />
				</ng-container>
			</div>
			<div class="col m-auto">
				<ng-container *ngTemplateOutlet="titleBlock"></ng-container>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #mediaPlaceholder>
	<div class="image-square image-square--placeholder d-flex align-items-center justify-content-center">
		<i class="fal fa-image"></i>
	</div>
</ng-template>

<ng-template #htmlTemplate>
	<ng-container *ngTemplateOutlet="titleBlock"></ng-container>
</ng-template>

<ng-template #defaultTemplate>
	<ng-container *ngTemplateOutlet="titleBlock"></ng-container>
</ng-template>
